import React, { useState } from "react";
import { LayoutDashboard, Activity, FileText } from "lucide-react";
import PageWrapper from "../../../components/layout/PageWrapper";
import Overview from "./Overview";
import LiveAnalysis from "./LiveAnalysis";
import Reports from "./Reports";

const TABS = [
  { key: "overview", label: "Overview", icon: LayoutDashboard },
  { key: "live", label: "Live Analysis", icon: Activity },
  { key: "reports", label: "Reports", icon: FileText },
];

const QAEngineer = () => {
  const [activeTab, setActiveTab] = useState("overview");
  const [selectedCommitId, setSelectedCommitId] = useState(null);

  const openCommit = (commitId) => {
    setSelectedCommitId(commitId);
    setActiveTab("live");
  };

  return (
    <PageWrapper
      title="AI QA Engineer"
      subtitle="Automatic impact analysis, risk scoring, and QA reports on every push and pull request."
    >
      {/* Tabs */}
      <div className="flex items-center gap-1 mb-6 border-b border-gray-200 dark:border-dark-100">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          const active = activeTab === tab.key;
          return (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition ${
                active
                  ? "border-primary-accent text-primary-accent"
                  : "border-transparent text-gray-500 dark:text-light-500 hover:text-gray-800 dark:hover:text-light-200"
              }`}
            >
              <Icon className="w-4 h-4" />
              {tab.label}
            </button>
          );
        })}
      </div>

      {activeTab === "overview" && <Overview onSelectCommit={openCommit} />}
      {activeTab === "live" && (
        <LiveAnalysis commitId={selectedCommitId} onClear={() => setSelectedCommitId(null)} />
      )}
      {activeTab === "reports" && <Reports onSelectCommit={openCommit} />}
    </PageWrapper>
  );
};

export default QAEngineer;
